// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"9354":"bf8f4996b11edc8b","9756":"5bd40752b6dbdb12"}[chunkId] + ".css";
};